import { getComponentClasses } from '@99designs/common/utils/app';
import PropTypes from 'prop-types';
import React from 'react';

export default class Field extends React.Component {
    constructor(props) {
        super(props);
        this.id = Math.random()
            .toString(36)
            .substr(2, 10);
    }

    renderTitle() {
        if (this.props.title) {
            return (
                <label className="field__title" htmlFor={this.id}>
                    {this.props.title}
                </label>
            );
        }
    }

    renderMessage() {
        if (this.props.message) {
            return <p className="field__message">{this.props.message}</p>;
        }
    }

    renderErrorMessage() {
        if (this.props.errorMessage) {
            return (
                <div className="field__validation">
                    <p className="field__validation__message">{this.props.errorMessage}</p>
                </div>
            );
        }
    }

    renderFieldInput(input) {
        return (
            <div className="field__input">
                {input && React.cloneElement(input, { id: this.id })}
            </div>
        );
    }

    render() {
        const classes = getComponentClasses('field', this.props.variations);
        const [firstChild, ...rest] = React.Children.toArray(this.props.children);

        return (
            <div className={classes} data-field-error={this.props.errorMessage}>
                {this.renderTitle()}
                {this.renderErrorMessage()}
                {this.renderFieldInput(firstChild)}
                {this.renderMessage()}

                {rest}
            </div>
        );
    }
}

Field.propTypes = {
    htmlFor: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    variations: PropTypes.array,
};

Field.defaultProps = {
    variations: [],
};



// WEBPACK FOOTER //
// ./js/common/components/Field.jsx